export const archiveTypeMap: Record<number, string> = {
  0: 'Promo was deleted',
  1: 'Promo was backdated',
  2: 'SKU removed from promo',
  3: 'Promo ended',
};

export const getArchiveTypeLabel = (archiveType: number): string => {
  return archiveTypeMap[archiveType] || '';
};
